<template>
    <div>
        <div class="header" :class="{'have_scroll': scrollPosition > 0}">
            <div class="header__left">
                <p @click="closeMenu"><span><img src="~ThemePath/images/icon/icon_hamburger.svg" alt=""></span><span>{{getTranslatedText('menu')}}</span></p>
            </div>
            <div class="header__right">
                <div @click="$router.push('/checkout')" class="header__cart" v-if="configGame[0].enabled || configGame[1].enabled || configGame[2].enabled">
                    <span><img src="~ThemePath/images/icon/icon_cart.png" alt=""></span>
                    <span>{{ getTranslatedText('checkout') }}</span>
                    <span>{{ $store.state.dataCheckout.length }}</span>
                </div>
                <div class="header__contain">
                    <div class="header__contain--logo">
                        <a @click="$router.push('/loto')" v-if="configGame[0].enabled">
                          <img src="~ThemePath/images/logo/loto_color.png" alt="loto hotpicks" />
                        </a>
                        <a @click="$router.push('/loto-plus')" v-if="configGame[2].enabled">
                          <img src="~ThemePath/images/logo/loto_plus_color.png" alt="loto hotpicks" />
                        </a>
                        <a @click="$router.push('/loto-vert')" v-if="configGame[1].enabled"><img src="~ThemePath/images/logo/loto_vert_color.png" alt="loto vert hotpicks" /></a>
                    </div>
                </div>
            </div>
        </div>
        <Menu ref="methodMenu" />
    </div>
</template>
<script>
import EventBus from '@/utils/EventBus'
import languageMixins from "@/mixins/language/language-mixins";
import configGameMinxins from "@/mixins/configGame/configGame-mixins";
import Menu from '@/components/menu';

export default {
  mixins: [languageMixins, configGameMinxins],
  components:{Menu},
  data() {
    return {
      scrollPosition:0
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    handleScroll(){
      this.scrollPosition  = window.pageYOffset || window.scrollY;
    },
    closeMenu(){
        this.$refs.methodMenu.handleToggleMenu();
    }
  }
};
</script>
<style lang="scss">
@import "~ThemePath/scss/header/_index.scss";
</style>
